import { MyCalendarCalendar } from "@/modules/myCalendar/myCalendarCalendar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MyCalendarList } from "@/modules/myCalendar/myCalendarList";
import { groupItemsByDayOfYear, useGetCalendarsQuery, useGetOutlookEventsQuery } from "./myCalendar.api";
import * as React from "react";
import * as analytics from "@/services/analytics";
import { Calendar, List, Loader2 } from "lucide-react";
import { Loader } from "@/components/ui/loader";
import { Separator } from "@/components/ui/separator";

export const MyCalendarView = () => {
  const getCalendarsQuery = useGetCalendarsQuery();
  const getOutlookEventsQuery = useGetOutlookEventsQuery();

  const eventsMap = React.useMemo(() => {
    if (!getOutlookEventsQuery.data) {
      return new Map();
    }

    if (getOutlookEventsQuery.data.status === "login_required") {
      return new Map();
    }

    return groupItemsByDayOfYear(getOutlookEventsQuery.data.data);
  }, [getOutlookEventsQuery.data]);

  React.useEffect(() => {
    if (!getCalendarsQuery.isLoading && getCalendarsQuery.data?.status === "login_required") {
      analytics.sharepointLogin();
      document.location.href = "/pf-auth/oauth/o365-login?redirect_view=my-calendar";
    }
  }, [getCalendarsQuery.isLoading, getCalendarsQuery.data]);

  if (getCalendarsQuery.isLoading || getOutlookEventsQuery.isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (getOutlookEventsQuery.isLoading || getOutlookEventsQuery.isLoading) {
    return <Loader />;
  }

  if (getOutlookEventsQuery.data!.status === "login_required") {
    return <Loader />;
  }

  return (
    <div className="container mx-auto px-4 py-6">
      <Tabs className="w-full" defaultValue={"calendar"}>
        <TabsList className="flex justify-start bg-transparent px-2">
          <TabsTrigger
            value={"calendar"}
            className="group flex items-center border-b-2 border-transparent px-4 py-4 text-sm font-medium text-gray-500 hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:bg-ui-app-background data-[state=active]:text-desert-sand-700"
          >
            <Calendar className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
            <span className="px-1">Calendar</span>
          </TabsTrigger>
          <TabsTrigger
            value={"list"}
            className="group flex items-center border-b-2 border-transparent px-4 py-4 text-sm font-medium text-gray-500 hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:bg-ui-app-background data-[state=active]:text-desert-sand-700"
          >
            <List className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
            <span className="px-1">All events</span>
          </TabsTrigger>
        </TabsList>
        <div className="mt-1">
          <Separator />
        </div>
        <TabsContent value="calendar" className="mt-5 rounded-xl bg-white p-5 shadow-md">
          <MyCalendarCalendar eventsMap={eventsMap} />
        </TabsContent>
        <TabsContent value="list" className="mt-5 rounded-xl bg-white p-5 shadow-md">
          <MyCalendarList events={getOutlookEventsQuery.data!.data} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
